<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex xs12">
        <va-card :title="$t('forms.inputs.load') + ' ' + this.$route.params.code">
          <form @submit.prevent>
            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-input
                  :label="$t('tables.loads.sequence')"
                  v-model="lecturerParams.load_sequence"
                  value="load.load_sequence"
                />
              </div>
              <div class="flex md4 sm6 xs12">
                <va-select
                  :label="$t('tables.load_sequence.conferent')"
                  v-model="lecturerParams.user.user_name"
                  keyBy="id"
                  textBy="name"
                  :options="conferents"
                  searchable
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input
                  :label="$t('tables.orders.dock')"
                  v-model="lecturerParams.dock"
                  value="load.dock"
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="vehicleName"
                  :label="$t('forms.selects.vehicle') + '  ' + lecturerParams.name"
                />
              </div>
              <div class="flex md1 sm1 xs12">
                <va-button
                  small
                  color="secondary"
                  icon="fa fa-search"
                  class="mr-1"
                  @click="getVehicleName(vehicleName)"
                />
                <va-button
                  small
                  color="secondary"
                  icon="fa fa-close"
                  class="mr-1"
                  @click="resetlabel()"
                />
              </div>

            </div>

            <div class="flex md8 sm8 xs12">
              <va-checkbox
                v-model="enabled"
                color="primary"
                :label=" $t('flags.save_checker')"
              />
            </div>

            <div class="row">
              <div class="flex md3 sm6 xs12">
                <va-button
                  medium
                  inline
                  color="secondary"
                  icon="fa fa-save"
                  class="mr-1"
                  @click="update(lecturerParams)"
                >
                  {{ $t('menu.update') }}
                </va-button>
              </div>

              <div class="flex md2 sm6 xs12">
                <va-button
                  medium
                  inline
                  color="#ff842b"
                  icon="fa fa-chevron-left"
                  class="ma-0"
                  :to="{ name: 'load_sequence', params: {
                    current_page: this.$route.params.current_page, 
                    search: this.$route.params.search, 
                    delivery_date: this.$route.params.delivery_date, 
                    perPage: this.$route.params.perPage }
                    }"
                >
                  {{ $t('menu.back') }}
                </va-button>
              </div>
            </div>
          </form>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
import LoadAPI from '@/services/LoadAPI'
import UserAPI from '@/services/UserAPI'
import VehicleAPI from '@/services/VehicleAPI'
import BackButton from '../../shared/BackButton'
import { mapState } from "vuex";

export default {
  name: 'form-load-sequence',
  components: { BackButton },
  data () {
    return {
      lecturerParams: {
        lecturerId: '',
        user: {
          user_id: '',
          user_name: '',
          delivery_date: '',
          vehicle: '',
        },
        vehicle: {
          id: ''
        },
        name: '',
        locality_id: '',
        dock: '',
        user_old: '',
        load_sequence: ''
      },
      conferents: [],
      enabled: false,
      vehicles: [],
      vehicleName: ''
    }
  },

  computed: {
    ...mapState(['currentLocality']),
  },

  async mounted(){

    await VehicleAPI.getAllVehicles().then(response => {
      this.vehicles = response.data.vehicles
    })

    await LoadAPI.getLoad(this.$route.params.load_id).then(response => {

      this.lecturerParams.lecturerId = response.data.load.id
      this.lecturerParams.dock = response.data.load.dock
      this.lecturerParams.user.delivery_date = response.data.load.delivery_date
      this.lecturerParams.user_old = response.data.load.user_id
      this.vehicleName = response.data.load.vehicle
      this.lecturerParams.locality_id = this.currentLocality.id
      this.lecturerParams.name = response.data.load.vehicle
      this.lecturerParams.load_sequence = response.data.load.load_sequence
      this.lecturerParams.vehicle.id = response.data.load.vehicle.name

      if (response.data.load.user != undefined) {
        this.lecturerParams.user.user_name = response.data.load.user
        this.lecturerParams.user.user_id = response.data.load.user_id
      }
    })

    await UserAPI.getUsersByRoleAndLocality(2, this.currentLocality.id).then(response => {
      this.conferents = response.data.users
    })
  },
  methods: {
    resetlabel() {
      this.lecturerParams.name = ""
      this.lecturerParams.vehicle.id = ""
      this.vehicleName = ""
    },
    async getVehicleName(vehicleName) {
      await VehicleAPI.getVehicleByName(vehicleName).then(response => {
        this.lecturerParams.vehicle.id = response.data.vehicle.id
        this.lecturerParams.name = response.data.vehicle.name
      }).catch(e => {
        showError(e)
      });
    },
    async update (lecturerParams) {
      if (!this.enabled) {
        await LoadAPI.updateLecturer(lecturerParams).then(response => {
          this.showToast(response.data.message, {
              icon: 'fa-thumbs-o-up',
              position: 'top-right',
              duration: 5000,
          })
          this.$router.push('/admin/tables/load_sequence')
        }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
      } else {
        await LoadAPI.updateForAllConferents(lecturerParams).then(response => {
          this.showToast(response.data.message, {
              icon: 'fa-thumbs-o-up',
              position: 'top-right',
              duration: 5000,
          })
          this.$router.push('/admin/tables/load_sequence')
        }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
      }
    }
  }
}
</script>